/** 与 optional 列表、Fiat-M 二级 Tab 一致：按 plates 260/261 归类 */
export function marketRowMatchesFavSubTab(theMarket, subTab) {
  if (!subTab) return true;
  const plates = Array.isArray(theMarket?.plates) ? theMarket.plates : [];
  const has260 = plates.includes(260);
  const has261 = plates.includes(261);
  if (subTab === "commodities") return has260;
  if (subTab === "stocks") return has261;
  if (subTab === "crypto") return !has260 && !has261;
  return true;
}

export function symbolMatchesFavSubTab(marketConfig, symbol, subTab) {
  if (!subTab) return true;
  const m = marketConfig?.[symbol];
  if (!m) return subTab === "crypto";
  return marketRowMatchesFavSubTab(m, subTab);
}

/**
 * 将某一子类（Crypto / Stocks / Commodities）编辑后的顺序合并回完整自选列表。
 * - 从 full 中移除本子类里已删掉的项；
 * - 保留非本子类项的相对顺序与位置；
 * - 本子类在 full 中占据的槽位按 editedSubtypeOrdered 依次填入（子类内部重排）。
 */
export function mergeFavSubtypeOrderIntoFull(full, editedSubtypeOrdered, marketConfig, subTab) {
  if (!subTab) return [...(editedSubtypeOrdered || [])];
  const belongs = (s) => symbolMatchesFavSubTab(marketConfig, s, subTab);
  const editedSet = new Set(editedSubtypeOrdered || []);
  const stripped = (Array.isArray(full) ? full : []).filter((s) => !belongs(s) || editedSet.has(s));
  let j = 0;
  return stripped.map((s) => {
    if (!belongs(s)) return s;
    return editedSubtypeOrdered[j++];
  });
}

/** 将 symbol 顶到「本子类」在全局列表中的第一个槽位（不跨类顶到全列表第一位）。 */
export function pinSubtypeSymbolInFull(full, symbol, marketConfig, subTab) {
  if (!subTab || !symbol) return [...(full || [])];
  const belongs = (s) => symbolMatchesFavSubTab(marketConfig, s, subTab);
  const arr = [...(full || [])];
  if (!arr.includes(symbol)) return arr;
  const without = arr.filter((s) => s !== symbol);
  const k = without.findIndex((s) => belongs(s));
  if (k === -1) return [...without, symbol];
  without.splice(k, 0, symbol);
  return without;
}
